import React from 'react'
import { Title } from '../Chart/style'
import { Container, Wrapper, Titles, Icon } from './style'

const Recent = () => {
    return (
        <Container>
            <Title>Recent Activity</Title>
            <Wrapper main>
                <Wrapper item>
                    <Icon.Home />
                    <Titles>
                        Your listing <a href=''>Luxury Family Home</a> has been approved!
                    </Titles>
                </Wrapper>
                <Wrapper item>
                    <Icon.Home />
                    <Titles>
                        Kathy Brown left a review on <a href=''>Renovated Apartment</a>
                    </Titles>
                </Wrapper>
                <Wrapper item>
                    <Icon.Home />
                    <Titles>
                        Someone favorites your <a href=''>Gorgeous Villa Bay</a> View listing!
                    </Titles>
                </Wrapper>
                <Wrapper item>
                    <Icon.Favorite />
                    <Titles>
                        Your listing <a href=''>Luxury Family Home</a> has been approved!
                    </Titles>
                </Wrapper>
                <Wrapper item>
                    <Icon.Home />
                    <Titles>
                        Kathy Brown left a review on <a href=''>Renovated Apartment</a>
                    </Titles>
                </Wrapper>
                <Wrapper item>
                    <Icon.Home />
                    <Titles>
                        Someone favorites your <a href=''>Gorgeous Villa Bay</a> View listing!
                    </Titles>
                </Wrapper>
            </Wrapper>
        </Container>
    )
}

export default Recent
